import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const ZtudiaLobby = () => {
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        // Leemos la sesión que guardó el interceptor
        const sessionData = sessionStorage.getItem('arcade_session');
        if (!sessionData) {
            navigate('/ztudia/'); // Si no hay sesión, lo regresamos al interceptor
            return;
        }
        setProfile(JSON.parse(sessionData));
    }, [navigate]);

    if (!profile) return null;

    return (
        <div style={{ padding: '40px', backgroundColor: '#111', minHeight: '100vh', color: 'white' }}>
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <h1>Centro Arcade - {profile.centerName}</h1>
                <p style={{ fontSize: '1.2rem', color: '#ccc' }}>
                    ¡Qué onda, <strong>{profile.nickname || profile.username}</strong>! ¿Qué quieres jugar hoy?
                </p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                {/* Botón para Tiro a Gol */}
                <div 
                    style={{ border: '2px solid #333', padding: '30px', borderRadius: '15px', cursor: 'pointer', textAlign: 'center', width: '250px' }}
                    onClick={() => navigate('/ztudia/gol')}
                >
                    <i className="bi bi-dribbble" style={{ fontSize: '4rem', color: '#e53935' }}></i>
                    <h3>Tiro a Gol</h3>
                    <p>1 vs 1 local</p>
                </div>

                {/* Puedes agregar más juegos aquí después */}
            </div>
            
            {/* Botón para Salir */}
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                 <button className="btn btn-outline-danger" onClick={() => {
                     sessionStorage.clear();
                     window.location.href = `${process.env.REACT_APP_ZTUDIA_URL}` //Regresa a su dashboard original
                 }}>
                     Cerrar Sesión Arcade
                 </button>
            </div>
        </div>
    );
};

export { ZtudiaLobby };